module.exports = __webpack_public_path__ + "img/goldregen-2020-100.9cade45c.jpg";